import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./HomeSwiper.css"
import "swiper/css";
import "swiper/css/pagination";
 import { Pagination } from "swiper";
import Swiper1 from "../../../../Assets/Images/swipper1-removebg-preview.png"
import Swiper2 from "../../../../Assets/Images/swipper2-removebg-preview.png"
import Swiper3 from "../../../../Assets/Images/swipper3-removebg-preview.png"

export default function HomeSwipper() {
  return (
    <div className="homeswiper">
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
         
        breakpoints={{
          300: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          400: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          550: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          770: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          980: {
            slidesPerView: 5,
            spaceBetween: 50
          },
       
        }}
         className="mySwiper"
      >
        <SwiperSlide>
          <img className="homeswipper-img" src={Swiper1} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
        <img className="homeswipper-img" src={Swiper2} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
        <img className="homeswipper-img" src={Swiper3} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
          <img className="homeswipper-img" src={Swiper2} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
        <img className="homeswipper-img" src={Swiper1} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
        <img className="homeswipper-img" src={Swiper3} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
        <img className="homeswipper-img" src={Swiper2} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
        <img className="homeswipper-img" src={Swiper3} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
          <img className="homeswipper-img" src={Swiper2} alt="dsd" />
        </SwiperSlide>
        <SwiperSlide>
        <img className="homeswipper-img" src={Swiper1} alt="dsd" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
